var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-template-sellsy" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "LayoutWithNavigation",
        { attrs: { sidebarWidth: "272px" } },
        [
          _c(
            "template",
            { slot: "navigation" },
            [
              _c("CompassInput", {
                staticClass: "automation-template-sellsy__search",
                attrs: {
                  prefixIcon: "search",
                  placeholder: _vm.$t.__(
                    "automation.AutomationTemplatesSellsy.placeholder_search"
                  ),
                  isEraseable: ""
                },
                model: {
                  value: _vm.searchTemplateValue,
                  callback: function($$v) {
                    _vm.searchTemplateValue = $$v
                  },
                  expression: "searchTemplateValue"
                }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "automation-template-sellsy__tags--title typographies-paragraph-small-semibold"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t.__("common.labels.categories")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "automation-template-sellsy__tags" },
                _vm._l(_vm.tagsTemplates, function(tag, index) {
                  return _c("CompassTagInteractive", {
                    key: index,
                    attrs: {
                      modelValue: tag.label,
                      variant: "selectable",
                      color: "gray",
                      isSelected: tag.selected,
                      valueLabel: tag.label
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleTagTemplates(index)
                      }
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.isFiltered
                ? _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.reset"),
                      leftIcon: "close"
                    },
                    on: { click: _vm.resetFilters }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "default" },
            [
              _vm.filteredTemplates.length > 0
                ? _c(
                    "div",
                    { staticClass: "automation-template-sellsy__container" },
                    _vm._l(_vm.filteredTemplates, function(template) {
                      return _c(
                        "AutomationTemplateCard",
                        { key: template.uuid, attrs: { template: template } },
                        [
                          _c(
                            "template",
                            { slot: "connector" },
                            [
                              template.objects.type
                                ? _vm._l(template.objects.type, function(
                                    object
                                  ) {
                                    return _c("CompassObject", {
                                      key: object.uuid,
                                      attrs: {
                                        object: object.type,
                                        size: "small"
                                      }
                                    })
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        2
                      )
                    }),
                    1
                  )
                : _c("CompassEmptyState", {
                    staticClass: "automation-template-sellsy__empty-state",
                    attrs: {
                      illustrationPath:
                        "/ressources/logged/img/illustrations/no-results.svg",
                      caption: _vm.translations.captionNoFilterResult
                    }
                  })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "automation-template-sellsy__banner" }, [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/sellsy-automations.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }